import {
  Account,
  Campaign,
  CampaignOptimizationValue,
  Goal,
  Micros,
  PerformanceGroup,
  Warning,
} from '@app/core/models/common.models';
import { Currency } from '@app/core/models/customer.models';
import { Observable } from 'rxjs';

import {
  CLICK_THROUGH_RATE,
  CLICKS,
  CONVERSION_RATE,
  CONVERSIONS,
  COST,
  COST_FOR_CLICK,
  COST_FOR_PROFIT,
  COST_FOR_REVENUE,
  COST_PER_CLICK,
  COST_PER_CONVERSION,
  COST_REVENUE_RATIO,
  IMPRESSIONS,
  PROFIT_GROSS,
  PROFIT_NET,
  RETURN_ON_INVESTMENT,
  REVENUE,
  ROAS,
} from '@app/core/models/metrics.constants';

export type RequestType = 'INIT' | 'MORE' | 'ALL';

export const PriorityOrder = { LOW: 1, MEDIUM: 2, HIGH: 3 };

export enum WarningResolveState {
  'NO_RESOLVE' = 0,
  'CAMPAIGNS_CHANGE' = 1,
  'GOAL_CHANGE' = 2,
}
export interface WarningFormatted extends Warning {
  resolveState: WarningResolveState;
}

export interface PGMetric {
  key: string;
  value: number | string;
}

export interface PGListItem extends PerformanceGroup {
  processing: boolean;
  expanded: boolean;
  originalName: string;
  usePGCurrency: boolean;
  pgCurrency: Currency;
  current$: Observable<any>;
  currentData;
  vcpmCurrentData?;
  currentChartData?;
  perf$: Observable<any>;
  perfData;
  warningsFormatted: WarningFormatted[];
  showWarningsBanner: boolean;
  warningsPriority: string;
  campaigns$: Observable<CampaignsListItem[]>;
  historic$: Observable<any>;
  historicChart: HistoricChartConfig | string;
  defaultForAccountsDetails: Account[];
  metrics?: [];
  budgetAmount?: number | null;
  defaultMetrics?: [];
  vcpmMetrics?: [];
  campaigns?: [];
  canMoveToDiffPG?: boolean;
  isMaxBidModalVisible?: boolean;
}

export interface CampaignsListItem extends Campaign {
  platform: string;
}

export interface HistoryData {
  [CLICK_THROUGH_RATE]: number;
  [CLICKS]: number;
  [CONVERSION_RATE]: number;
  [CONVERSIONS]: number;
  [COST]: Micros;
  [COST_FOR_CLICK]: Micros;
  [COST_FOR_PROFIT]: Micros;
  [COST_FOR_REVENUE]: Micros;
  [COST_PER_CLICK]: Micros;
  [COST_PER_CONVERSION]: Micros;
  [COST_REVENUE_RATIO]: number;
  [IMPRESSIONS]: number;
  [PROFIT_GROSS]: Micros;
  [PROFIT_NET]: Micros;
  [ROAS]: number;
  [REVENUE]: Micros;
  [RETURN_ON_INVESTMENT]: number;
  date: string;
  enabled: boolean;
  goals: Goal[];
}

export interface HistoricChartConfig {
  data: HistoryData[];
  currency: Currency;
  optiType?: CampaignOptimizationValue;
  goals?: Goal[];
}
